import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const HomeFilledIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 28 25">
      <path
        d="M27.8427 12C27.8427 12.8438 27.1396 13.5 26.3427 13.5H24.8427L24.8896 21C24.8896 22.6875 23.5302 24 21.8896 24H6.8896C5.2021 24 3.8896 22.6875 3.8896 21V13.5H2.3896C1.54585 13.5 0.889601 12.8438 0.889601 12C0.889601 11.5781 1.03023 11.2031 1.35835 10.875L13.3584 0.421875C13.6865 0.09375 14.0615 0 14.3896 0C14.7177 0 15.0927 0.140625 15.374 0.375L27.3271 10.875C27.7021 11.2031 27.8896 11.5781 27.8427 12Z"
        fill="#00B6B9"
      />
    </SvgIcon>
  );
};

export default HomeFilledIcon;
